import {skillsSvg as Icon__small__skillsSvg} from '../Icon__small/Icon__small--skills.js';

export var skills = {
  name: 'skills',
  category: 'icon',
  colorable: true,
  svg: Icon__small__skillsSvg,
};
